var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-flex justify-center"},[_c('bounce-loader',{attrs:{"color":"#ffffff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }